import { Input } from '@angular/core';
import { Monitor } from '../../../types/monitor';

export class Card {
    @Input()
    monitor: Monitor;
}
